export enum FeatureFlagKey {
  IMPORTED_SHAPEFILES_FEATURE_FLAG = 'cfvweb.dmb.imported-shapefiles',
  OTHER_IMAGERY_FEATURE_FLAG = 'cfvweb.dmb.other-imagery',
  CROP_WATER_FEATURE_FLAG = 'cfvweb.dmb.crop-water-use',
  SCOUTING_ACTIVITIES = 'cfvweb.dmb.scouting-activities',
  FHA_EXPANDED_LEGEND_FEATURE_FLAG = 'cfvweb.dmb.fha-expanded-legend',
  DMB_TARGET_POPULATION_FEATURE_FLAG = 'cfvweb.dmb.target-population',
  PRECISION_PLANTING_MAPS_FEATURE_FLAG = 'cfvweb.dmb.precision-planting-maps',
  PRESCRIPTION_MAPS_WEB_FEATURE_FLAG = 'cfvweb.dmb.display-prescriptions-web',
  SCOUTING_REGIONS = 'cfvweb.dmb.scouting-regions',

  // Launch Darkly
  OL_HARVEST = 'web.harvest-yield-endpoint-migration',
  DELARO_TRIAL_BLOCK = 'dmb.delaro-2022-trial-regions-visualization',
  MICROSOFT_WEATHER = 'web.microsoft-weather',
  MICROSOFT_WEATHER_GDD = 'web.microsoft-weather-gdd',
  MICROSOFT_WEATHER_GDD_GLOBAL_RELEASE = 'web.microsoft-weather-gdd-global-release',
  COMMERCIAL_POLICY_HISTORICAL_WEATHER = 'web.historical-weather-commercial-policy',
  COMMERCIAL_POLICY_SCOUTING_ADD_PHOTO = 'web.scouting-add-photo-commercial-policy',
  MULTI_OPERATION_SELECTION = 'web.multi-operation-selection.dmb',
  WEB_DMB_FRR_AS_APPLIED = 'web-dmb-frr-as-applied',
  WEB_DMB_ENHANCED_SCOUTING = 'web-dmb-enhanced-scouting',
  WEB_DMB_ZOOM_ENHANCEMENTS = 'web-dmb-zoom-enhancements',
  WEB_DMB_NEW_ARCH = 'web-fieldview-new-arch-dmb',
  PLANET_LABS_POC = 'web.planet-labs-poc',
  WEB_FIELD_SELECTION_NEW_ARCH = 'web-fieldview-new-arch-field-selection',
  COMMERCIAL_POLICY_FIELD_REGION_REPORT = 'dmb.frr-commercial-policy-phase-1',
  DMB_HIDE_SPATIAL_DISPLAY_FEATURE = 'dmb.hide-spatial-display-feature',
  DMB_SPRAY_ASSIST = 'dmb.spray-assist-feature',
  DMB_STD_YIELD = 'dmb-std-yield',
  SCRIPT_CREATOR_PLUGIN = 'script-creator-plugin-version',
  DMB_APPLICATION_CARD = 'dmb.application-card',
  DMB_CROP_SEASON_FILTER = 'dmb.crop-season-filter-for-application-data',
  WEB_PLANTING_ARD_DATA = 'web.planting-ard-data',
  DMB_WEB_AG_VIZ = 'dmb-web-ag-viz',
  WEB_HARVEST_ARD_DATA = 'web-harvest-ard-data',
  DMB_FIELD_RETRIEVAL_MIGRATION = 'dmb-field-retrieval-migration'
}

export type FeatureFlagValue = {
  value: boolean;
}

export type FeatureFlagsConfig = Record<FeatureFlagKey, FeatureFlagValue | undefined>;
